// Custom jQuery
// ----------------------------------- 

// Translate JQuery validate
const {validate, steps} = $.fn;
if (document.documentElement.lang === 'nl') {

    // noinspection SpellCheckingInspection
    $.extend($.validator.messages, {
        required: 'Dit is een verplicht veld.',
        remote: 'Controleer dit veld.',
        email: 'Vul hier een geldig e-mailadres in.',
        url: 'Vul hier een geldige URL in.',
        date: 'Vul hier een geldige datum in.',
        dateISO: 'Vul hier een geldige datum in (ISO-formaat).',
        number: 'Vul hier een geldig getal in.',
        digits: 'Vul hier alleen getallen in.',
        creditcard: 'Vul hier een geldig creditcardnummer in.',
        equalTo: 'Vul hier dezelfde waarde in.',
        extension: 'Vul hier een waarde in met een geldige extensie.',
        maxlength: $.validator.format('Vul hier maximaal {0} tekens in.'),
        minlength: $.validator.format('Vul hier minimaal {0} tekens in.'),
        rangelength: $.validator.format('Vul hier een waarde in van minimaal {0} en maximaal {1} tekens.'),
        range: $.validator.format('Vul hier een waarde in van minimaal {0} en maximaal {1}.'),
        max: $.validator.format('Vul hier een waarde in kleiner dan of gelijk aan {0}.'),
        min: $.validator.format('Vul hier een waarde in groter dan of gelijk aan {0}.'),
        step: $.validator.format('Vul hier een veelvoud van {0} in.'),

        // For validations in additional-methods.js
        iban: 'Vul hier een geldig IBAN in.',
        dateNL: 'Vul hier een geldige datum in.',
        phoneNL: 'Vul hier een geldig Nederlands telefoonnummer in.',
        mobileNL: 'Vul hier een geldig Nederlands mobiel telefoonnummer in.',
        postalcodeNL: 'Vul hier een geldige postcode in.',
        bankaccountNL: 'Vul hier een geldig bankrekeningnummer in.',
        giroaccountNL: 'Vul hier een geldig gironummer in.',
        bankorgiroaccountNL: 'Vul hier een geldig bank- of gironummer in.'
    });

    // noinspection SpellCheckingInspection
    $.extend(steps.defaults, {
        labels: {
            current: 'Huidige stap:',
            pagination: 'Paginering ',
            finish: 'Einde',
            next: 'Volgende',
            previous: 'Vorige',
            loading: 'Laden ...'
        }
    });
}

$.validator.addMethod('greaterThan', function (value, element, param) {
    const $otherElement = $(param);
    return parseInt(value, 10) >= parseInt($otherElement.val(), 10);
});

$.validator.addMethod('regex', function (value, element, regexp) {
    const re = new RegExp(regexp);
    return this.optional(element) || re.test(value);
}, 'Value is invalid.');

$.validator.addMethod('unique', function (value, element) {
    const parentForm = $(element).closest('form');
    let timeRepeated = 0;
    if (value) {
        $(parentForm.find('input, select')).each(function () {
            if ($(this).val() === value) {
                timeRepeated++;
            }
        });
    }
    return timeRepeated === 1 || timeRepeated === 0;

}, 'You cannot use this value more than once.');

Date.prototype.toInvariantDateString = function () {

    const mm = this.getMonth() + 1; // getMonth() is zero-based
    const dd = this.getDate();

    return [this.getFullYear(), (mm > 9 ? '' : '0') + mm, (dd > 9 ? '' : '0') + dd].join('-');
};

function toggleNawFields(element) {
    const $element = $(element);
    const $panel = $element.closest('.panel');
    const $naw = $panel.find('.naw');

    if (element.checked) {
        $naw.removeClass('hidden');
    } else {
        $naw.addClass('hidden');
    }
}

const select2Options = {
    theme: 'bootstrap', width: '100%'
};

const DiacriticsRemovalMap = [{
    'base': 'A',
    'letters': /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g
}, {'base': 'AA', 'letters': /\uA732/g}, {'base': 'AE', 'letters': /[\u00C6\u01FC\u01E2]/g}, {
    'base': 'AO', 'letters': /\uA734/g
}, {'base': 'AU', 'letters': /\uA736/g}, {'base': 'AV', 'letters': /[\uA738\uA73A]/g}, {
    'base': 'AY', 'letters': /\uA73C/g
}, {'base': 'B', 'letters': /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g}, {
    'base': 'C', 'letters': /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g
}, {
    'base': 'D', 'letters': /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g
}, {'base': 'DZ', 'letters': /[\u01F1\u01C4]/g}, {'base': 'Dz', 'letters': /[\u01F2\u01C5]/g}, {
    'base': 'E',
    'letters': /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g
}, {'base': 'F', 'letters': /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g}, {
    'base': 'G',
    'letters': /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g
}, {
    'base': 'H', 'letters': /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g
}, {
    'base': 'I',
    'letters': /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g
}, {'base': 'J', 'letters': /[\u004A\u24BF\uFF2A\u0134\u0248]/g}, {
    'base': 'K', 'letters': /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g
}, {
    'base': 'L',
    'letters': /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g
}, {'base': 'LJ', 'letters': /\u01C7/g}, {'base': 'Lj', 'letters': /\u01C8/g}, {
    'base': 'M', 'letters': /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g
}, {
    'base': 'N',
    'letters': /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g
}, {'base': 'NJ', 'letters': /\u01CA/g}, {'base': 'Nj', 'letters': /\u01CB/g}, {
    'base': 'O',
    'letters': /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g
}, {'base': 'OI', 'letters': /\u01A2/g}, {'base': 'OO', 'letters': /\uA74E/g}, {
    'base': 'OU', 'letters': /\u0222/g
}, {'base': 'P', 'letters': /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g}, {
    'base': 'Q', 'letters': /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g
}, {
    'base': 'R',
    'letters': /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g
}, {
    'base': 'S',
    'letters': /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g
}, {
    'base': 'T',
    'letters': /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g
}, {'base': 'TZ', 'letters': /\uA728/g}, {
    'base': 'U',
    'letters': /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g
}, {'base': 'V', 'letters': /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g}, {
    'base': 'VY', 'letters': /\uA760/g
}, {'base': 'W', 'letters': /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g}, {
    'base': 'X', 'letters': /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g
}, {
    'base': 'Y',
    'letters': /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g
}, {
    'base': 'Z', 'letters': /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g
}, {
    'base': 'a',
    'letters': /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g
}, {'base': 'aa', 'letters': /\uA733/g}, {'base': 'ae', 'letters': /[\u00E6\u01FD\u01E3]/g}, {
    'base': 'ao', 'letters': /\uA735/g
}, {'base': 'au', 'letters': /\uA737/g}, {'base': 'av', 'letters': /[\uA739\uA73B]/g}, {
    'base': 'ay', 'letters': /\uA73D/g
}, {'base': 'b', 'letters': /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g}, {
    'base': 'c', 'letters': /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g
}, {
    'base': 'd', 'letters': /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g
}, {'base': 'dz', 'letters': /[\u01F3\u01C6]/g}, {
    'base': 'e',
    'letters': /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g
}, {'base': 'f', 'letters': /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g}, {
    'base': 'g',
    'letters': /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g
}, {
    'base': 'h',
    'letters': /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g
}, {'base': 'hv', 'letters': /\u0195/g}, {
    'base': 'i',
    'letters': /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g
}, {'base': 'j', 'letters': /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g}, {
    'base': 'k', 'letters': /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g
}, {
    'base': 'l',
    'letters': /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g
}, {'base': 'lj', 'letters': /\u01C9/g}, {
    'base': 'm', 'letters': /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g
}, {
    'base': 'n',
    'letters': /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g
}, {'base': 'nj', 'letters': /\u01CC/g}, {
    'base': 'o',
    'letters': /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g
}, {'base': 'oi', 'letters': /\u01A3/g}, {'base': 'ou', 'letters': /\u0223/g}, {
    'base': 'oo', 'letters': /\uA74F/g
}, {'base': 'p', 'letters': /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g}, {
    'base': 'q', 'letters': /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g
}, {
    'base': 'r',
    'letters': /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g
}, {
    'base': 's',
    'letters': /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g
}, {
    'base': 't',
    'letters': /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g
}, {'base': 'tz', 'letters': /\uA729/g}, {
    'base': 'u',
    'letters': /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g
}, {'base': 'v', 'letters': /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g}, {
    'base': 'vy', 'letters': /\uA761/g
}, {'base': 'w', 'letters': /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g}, {
    'base': 'x', 'letters': /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g
}, {
    'base': 'y',
    'letters': /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g
}, {
    'base': 'z', 'letters': /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g
}];

function removeDiacritics(str) {
    for (let i = 0; i < DiacriticsRemovalMap.length; i++) {
        str = str.replace(DiacriticsRemovalMap[i].letters, DiacriticsRemovalMap[i].base);
    }
    return str.split(' ').join('.');
}

function pullUserMessages(url, callbackUrl, currentPath) {
    let cancelIntervalCount = 0;
    const maxRequestCount = 3;
    const pollInterval = setInterval(function () {
        $.ajax({
            dataType: 'json',
            url: url,
            async: true,
            data: {currentPath: currentPath},
            timeout: 2000,
            error: function () {
                cancelIntervalCount++;
                if (cancelIntervalCount >= maxRequestCount) clearInterval(pollInterval);
            },
            success: function (result) {
                if (!result.messages.length) {
                    cancelIntervalCount++;
                    if (cancelIntervalCount >= maxRequestCount) clearInterval(pollInterval);
                    return;
                }
                let texts = [];
                let titles = [];
                const types = [];
                let i;
                let message = {};
                for (i = 0; i < result.messages.length; i++) {
                    message = result.messages[i];
                    texts.push(message.value);
                    titles.push(message.title);
                    types.push(message.icon);
                }
                // Always take the lowest
                types.sort();
                texts = texts.filter(function (item, pos) {
                    return texts.indexOf(item) === pos;
                });
                titles = titles.filter(function (item, pos) {
                    return titles.indexOf(item) === pos;
                });
                let type = '';
                switch (types[types.length - 1]) {
                    case 0:
                        type = 'success';
                        break;
                    case 1:
                        type = 'warning';
                        break;
                    case 2:
                        type = 'error';
                        break;
                }
                swal(titles.join(', '), texts.join(', '), type);
                for (i = 0; i < result.messages.length; i++) {
                    message = result.messages[i];
                    $.ajax({
                        url: callbackUrl, data: {userMessageId: message.id}, async: false, error: function () {
                            console.log('message with id ' + message.id + ' could not be marked as read.');
                        }
                    });
                }

                clearInterval(pollInterval);
            }
        });
    }, 1000);
}

function registerDatePickerEvents($datePicker) {
    $datePicker.on('changeDate', function (event) {
        if (typeof event.date === 'undefined') return;
        $(this).find('input[type=hidden]').val(event.date.toInvariantDateString());
    });
}

function getProductProperties(productId, tenantId, success) {

    if (!productId) {
        success({sellingPrice: null});
        return;
    }

    $.ajax({
        url: '/Core/TenantProduct/GetProductProperties', method: 'get', data: {
            id: productId, tenantId: tenantId
        }, cache: false, contentType: 'json', success: success
    });
}

/**
 * Bind discount percentage and price to each other.
 * @param {object} options - The options object.
 * @param {jQuery} options.$discountPercentage - The discount percentage input field.
 * @param {jQuery} options.$discountPrice - The discount price input field.
 * @param {jQuery} options.$manualSellingPrice - The manual selling price input field.
 * @param {function} options.getProductId - The function to get the product id.
 * @param {string} options.tenantId - The tenant id.
 */
function bindDiscount(options) {
    const $discountPercentage = options.$discountPercentage;
    const $discountPrice = options.$discountPrice;
    const $manualSellingPrice = options.$manualSellingPrice;
    const getProductId = options.getProductId;
    const tenantId = options.tenantId;

    $discountPercentage.on('change', function () {
        // Percentage calculated in euro
        const $this = $(this);
        const productId = typeof getProductId === 'function' ? getProductId() : null;
        if (productId === 'Choose a product') {
            swal('Error', 'Please choose a product before giving any discounts.', 'error');
            $this.val('');
            return;
        }
        const inputValue = $this.val();
        if (!inputValue) {
            $discountPercentage.val('');
            $discountPrice.val('');
            return;
        }

        if (inputValue < 1) {
            swal('Error', 'Discount cannot be lower than 1', 'error');
            $this.val('');
            return;
        }

        if (inputValue > 100) {
            swal('Error', 'Discount cannot be higher than 100', 'error');
            $this.val('');
            return;
        }
        const percentage = inputValue.replace(',', '.');
        getProductProperties(productId, tenantId, function (data) {
            const manualSellingPrice = $manualSellingPrice ? parseFloat($manualSellingPrice.val()) : NaN;
            const discountPrice = (!isNaN(manualSellingPrice) ? manualSellingPrice : data.sellingPrice) / 100 * percentage;
            if (isNaN(discountPrice)) {
                $discountPercentage.val('');
                $discountPrice.val('');
                return;
            }
            let value = (Math.round(discountPrice * 100) / 100).toFixed(2);
            if ($discountPrice.attr('type') === 'text') {
                value = value.replace('.', ',');
            }
            $discountPrice.val(value);
            $discountPrice.trigger('change');
        });
    });

    $discountPrice.on('change', function () {
        // Euro calculated in percentage
        const $this = $(this);
        const productId = getProductId();
        if (productId === 'Choose a product') {
            swal('Error', 'Please choose a product before giving any discounts.', 'error');
            $this.val('');
            return;
        }
        const inputValue = $this.val();
        if (!inputValue) {
            $discountPercentage.val('');
            $discountPrice.val('');
            return;
        }
        const discountPrice = parseFloat(inputValue.replace(',', '.'));
        getProductProperties(productId, tenantId, function (data) {
            const manualSellingPrice = $manualSellingPrice ? parseFloat($manualSellingPrice.val()) : NaN;
            const discountPercentage = data.sellingPrice ? discountPrice / (!isNaN(manualSellingPrice) ? manualSellingPrice : data.sellingPrice) * 100 : 0;

            if (isNaN(discountPercentage)) {
                $discountPercentage.val('');
                $discountPrice.val('');
                return;
            }
            let value = (Math.round(discountPercentage * 100) / 100).toString();
            if ($discountPercentage.attr('type') === 'text') {
                value = value.replace('.', ',');
            }
            $discountPercentage.val(value);
        });
    });
}

/**
 * Initialize a wizard form.
 * @param $form The form to initialize.
 * @param addRules The function to add rules to the form.
 * @param options The options object.
 */
function initWizard($form, addRules, options) {
    if (!options) options = {};

    if (!validate) return;

    $form.on('click', 'a[value-for]', function () {
        const $this = $(this);
        const id = $this.attr('value-for');
        const $input = $('[id="' + id + '"]');
        const headerId = $input.closest('fieldset').attr('aria-labelledby');
        $('a[href="#' + headerId + '"]').click();

        if ($input.data('provide') !== 'datepicker') $input.focus();
    });

    $form.on('change', 'input, select', function () {
        const $this = $(this);
        const id = $.escapeSelector($this.attr('id'));
        const $label = $('label[value-for="' + id + '"]');
        const value = $this.val();
        if (value) {
            $('[data-hide-if-empty="' + id + '"]').show();
        } else {
            $('[data-hide-if-empty="' + id + '"]').hide();
        }

        if ($this.is('select')) {
            const $options = $this.find('option:selected');
            const values = [];
            $.each($options, function (i, value) {
                values.push($(value).text());
            });
            $label.text(values.join(', '));
        } else if ($this.is(':checkbox')) {
            $label.html('<span class="fa fa-' + ($this.is(':checked') ? 'check text-success' : 'times text-danger') + '"></span>');
        } else if ($this.attr('type') === 'file') {
            $label
                .text($this[0].files.length);
        } else {
            $label
                .text(value);
        }

    });

    $form.validate({
        onkeyup: true, ignore: ':disabled,:hidden', errorPlacement: function (error, element) {
            const {errorClass, errorCallback} = options;

            if (typeof errorCallback === 'function') {
                const result = errorCallback(error, element);
                if (typeof result === 'boolean' && !result) return;
            }

            error.css({
                width: '100%'
            });

            const errorClassString = errorClass || 'col-md-2';
            element.closest('div.row').append($('<div class="' + errorClassString + '"></div>').append(error));
        }, success: function (element) {

        }
    });

    $form.children('div').steps({
        headerTag: 'h4',
        bodyTag: 'fieldset',
        labels: {
            finish: 'Save'
        },
        enableAllSteps: options.enableAllSteps || false,
        transitionEffect: 'slideLeft',
        onStepChanging: function (event, currentIndex, newIndex) {

            if (newIndex < currentIndex) {
                return true;
            }

            if (typeof options.onStepChanging === 'function') {
                const returnValue = options.onStepChanging(event, currentIndex, newIndex);

                if (typeof returnValue === 'boolean') return $form.valid() && returnValue;
            }

            return $form.valid();
        },
        onStepChanged: function (event, currentIndex, priorIndex) {
            if (typeof options.onStepChanged === 'function') options.onStepChanged(event, currentIndex, priorIndex);
        },
        onFinishing: function (event, currentIndex) {
            if (typeof options.onFinishing === 'function') options.onFinishing(event, currentIndex);

            const validator = $form.validate();
            const ignores = validator.settings.ignore;

            validator.settings.ignore = ':disabled';
            const isValid = $form.valid();
            validator.settings.ignore = ignores;

            const messages = validator.errorList.map(x => x.element.id + ': ' + x.message).join('\n');

            if (!isValid) {
                swal('Invalid', messages, 'error');
                return false;
            }

            return true;
        },
        'onFinished': function () {
            $form.submit();
        }
    });
    addRules();

    // JQuery steps overwrites the following events, so we have to do it afterward.
    $('[data-toggle="tooltip"]').tooltip({
        container: 'body'
    });

    const $selects = $form.find('select').not('[data-wizard-initialize="false"]');
    const $inputs = $form.find('input');

    $selects.select2(select2Options);

    $selects.trigger('change', [true]);
    $inputs.trigger('change', [true]);
}

function openModal(url, closed) {
    const $modal = $('#modal');
    $modal.modal('show').find('.modal-content').load(url);
    
    $modal.one('hidden.bs.modal', function () {
        $modal.find('.modal-content').empty();
        if (typeof closed === 'function') {
            closed();
        }
    });

    return $modal;
}

function uploadAttachmentChanged(element) {
    const $attachment = $(element)
        .closest('.attachment');

    $attachment.find('span#upload-file-info').remove();

    for (let i = 0; i < element.files.length; i++) {
        const item = element.files.item(i);
        const $span = $('<span class="label label-info" style="margin-right: 2px;" id="upload-file-info"></span>');
        $span.text(item.name);
        $span.attr('title', item.name);
        $attachment
            .append($span);
    }
}

let _fnFormSubmitted;

function formSubmitted(fn) {
    _fnFormSubmitted = fn;
}

function registerAsyncForms() {
    const formSelector = 'form[async="true"]';
    const $form = $(formSelector);
    $('body').on('click', 'a[for]', function () {
        // Edge doesn't understand the a[for] selector on the form itself
        const parentForm = $(this).closest(formSelector);
        if (!parentForm) {
            return;
        }

        const $field = $('#' + $(this).attr('for'));
        if ($field.is('select')) {
            $field.prop('disabled', false);
            return;
        }

        if ($field.is('input') && $field.attr('type') === 'checkbox') {
            $field.prop('disabled', false);
            return;
        }

        const inputFieldFor = $(this).attr('for');
        const inputField = $('#' + inputFieldFor);
        if (inputField) {
            inputField.focus();
        }

        $field.prop('readonly', false);
    });
    $form.validate({
        ignore: ':disabled', 'submitHandler': function (form) {
            const $form = $(form);
            const method = $form.attr('method').toLowerCase();
            const url = $form.attr('action');
            $form.find('select').prop('disabled', false);
            if (!$form.valid()) {
                $form.find('select').prop('disabled', true);
                return;
            }
            const values = $form.serialize();
            $form.find('input, select, a, button').prop('disabled', true);

            const fnDone = function (data) {
                $form.find('input, select, a, button').prop('disabled', false);
                if (typeof _fnFormSubmitted === 'function') _fnFormSubmitted($form, data); else $form.find('[data-dismiss="modal"]').trigger('click');
            };
            const fnFail = function (data) {
                if (!data.responseJSON) {
                    console.warn(data);
                    return;
                }

                for (let i = 0; i < data.responseJSON.length; i++) {
                    const {errorMessage} = data.responseJSON[i];
                    alert(errorMessage);
                }
            };
            switch (method) {
                case 'get':
                    $.get(url, values, fnDone).fail(fnFail);
                    break;
                case 'post':
                    $.post(url, values, fnDone).fail(fnFail);
                    break;
            }
        }, errorPlacement: function (error, element) {
            error.css({
                width: '100%'
            });
            let $element = element
                .closest('.append-error');

            if (!$element.length) $element = element
                .parent()
                .parent();

            $element.append($('<div class="col-md-offset-4 col-md-8 error-container"></div>').append(error));
        }, success: function (element) {
            let $element = element
                .closest('.append-error');

            if (!$element.length) $element = element
                .parent()
                .parent();

            $element
                .find('div.error-container')
                .remove();
        }
    });
}

function registerSelect2() {
    $.each($('select[data-initialize!="false"]:not(.select2-hidden-accessible)'), function (i, value) {
        // noinspection JSCheckFunctionSignatures
        const $this = $(value);
        if ($this.parents('.dont-init-select2').length) {
            return;
        }

        // Check if we are inside a modal, if so, we need to set the parent to the modal itself
        const $modal = $this.closest('#modal');

        const options = Object.assign({
            allowClear: $this.data('allow-clear') || false,
            tags: $this.data('tags') || false,
            placeholder: $this.data('placeholder') || null,
            dropdownParent: $modal.length > 0 ? $modal : null
        }, select2Options);

        $this.select2(options);
    });
}

function formatDate(date) {
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1), day = '' + d.getDate();
    const year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join('-');
}

function setCookie(name, value, days) {
    let expires = '';
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + (value || '') + expires + '; path=/';
}


function registerDateTimePickers() {
    const pickers = $('.datetimepicker');

    pickers.each((index, element) => {
        const options = {
            locale: 'nl', icons: {
                time: 'fa fa-clock-o', date: 'fa fa-calendar', up: 'fa fa-arrow-up', down: 'fa fa-arrow-down'
            }
        };
        const {dataset} = element;
        if (dataset.format) {
            options.format = dataset.format;
        }

        $(element).datetimepicker(options);
    });

    registerDatePickerEvents($('div.date'));
}

(function (window, document, $) {
    const $document = $(document);
    $document.ready(function () {
        registerSelect2();
        registerDateTimePickers();
        registerAsyncForms();
    });

    $document.on('hidden.bs.modal', function (_) {
        if ($('.modal:visible').length) {
            $('body').addClass('modal-open');
        }
    });

    $document.on('hidden.bs.modal', '#modal-tooltip', function (_) {
        $(this).removeData('bs.modal');
        $(this).find('.modal-content').empty();
    });

    $document.find('form').not('[data-click-once="false"]').on('submit', function () {
        const $buttons = $document.find('button');
        $buttons.addClass('disabled');
        $buttons.prop('disabled', true);

        const $a = $document.find('a');
        $a.addClass('disabled');
    });

    let searchTimeout;
    $document.on('keydown', 'input.search-number-range', function (event) {
        if (event.key === 'Enter') event.preventDefault();

        if (searchTimeout) clearTimeout(searchTimeout);

        searchTimeout = setTimeout(function () {
            $(event.currentTarget).trigger('change');
        }, 650);
    });

    $document.on('change', 'input.search-number-range', function (_) {
        const $table = $('#phone-number-table');
        $table.find('tr').show();
        $table.find('td.phone-number:not(:contains(' + $.escapeSelector($(this).val()) + '))')
            .parent('tr')
            .hide();
    });

    $document.on('click', '[data-disable]', event => {
        const target = event.target.closest('[data-disable]');
        target.disabled = true;
        console.log('disabled');
    });

    $document.on('click', '[data-confirm]', event => {
        const target = event.target.closest('[data-confirm]');
        if (target.dataset.isConfirmed) {
            return;
        }

        event.preventDefault();

        const isDutch = document.documentElement.lang === 'nl';
        // noinspection SpellCheckingInspection
        swal({
            title: isDutch ? 'Weet je het zeker?' : 'Are you sure?',
            text: target.dataset.confirm,
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: isDutch ? 'Ja' : 'Yes',
            cancelButtonText: isDutch ? 'Nee' : 'No',
        }, function (isConfirm) {
            if (isConfirm) {
                target.dataset.isConfirmed = true;
                target.click();
            }
        });
    });

    $(document).on('change', '.form-group .input-group.date input[data-provide="datepicker"]', function () {
        const $this = $(this);
        const value = $this.val();
        const $formGroup = $this.closest('div.form-group');

        const id = $this.attr('id').replace('datepicker_', '');

        const $hiddenInput = $formGroup.find('input#' + $.escapeSelector(id));

        if (!value) {
            $hiddenInput.val(null);
        } else {
            const dateParts = value.split('-');
            $hiddenInput.val(formatDate(dateParts[2] + '-' + dateParts[1] + '-' + dateParts[0]));
            $hiddenInput.change();
        }
    });

    $(document).on('click', 'a[disabled]', event => event.preventDefault());

})(window, document, window.jQuery);
